import axios from 'axios';

class HttpClient {
  public async get<T>(url: string, headers?: any) {
    try {
      return await axios.get<T>(url, { headers });
    } catch (error) {
      throw error;
    }
  }

  public async post<T>(url: string, input?: any, headers?: any) {
    try {
      return await axios.post<T>(url, input || null, { headers });
    } catch (error) {
      throw error;
    }
  }

  public async put<T>(url: string, input?: any, headers?: any) {
    try {
      return await axios.put<T>(url, input || null, { headers });
    } catch (error) {
      throw error;
    }
  }

  public async delete<T>(url: string, headers?: any) {
    try {
      return await axios.delete<T>(url, { headers });
    } catch (error) {
      throw error;
    }
  }
}

export default new HttpClient();
